import cn from 'clsx';
import {useTranslation} from 'next-i18next';
import Countdown from 'react-countdown';

import Close from '@/public/icons/timerClose.svg';

import css from '../styles/styles.module.css';

const zeroPad = (value) => String(value).padStart(2, '0');

type TimerProps = {
  endDate: Date;
  isRounded?: boolean;
  onClose?: () => void;
  headline?: string | null;
};

const Timer = ({endDate, isRounded, onClose, headline}: TimerProps) => {
  const {t} = useTranslation('common');

  const renderer = ({days, hours, minutes, seconds}) => {
    return (
      <div className={css.timer}>
        <div className={css.timerCounter}>
          <div className={css.timerValue}>{zeroPad(days)}</div>
          <div className={css.timerTitle}>{String(t('timer.days'))}</div>
        </div>
        <div className={css.timerCounter}>
          <div className={css.timerValue}>{zeroPad(hours)}</div>
          <div className={css.timerTitle}>{String(t('timer.hours'))}</div>
        </div>
        <div className={css.timerCounter}>
          <div className={css.timerValue}>{zeroPad(minutes)}</div>
          <div className={css.timerTitle}>{String(t('timer.minutes'))}</div>
        </div>
        <div className={css.timerCounter}>
          <div className={css.timerValue}>{zeroPad(seconds)}</div>
          <div className={css.timerTitle}>{String(t('timer.seconds'))}</div>
        </div>
      </div>
    );
  };

  return (
    <div
      className={cn(css.timerWrapper, {
        [css.rounded]: isRounded,
      })}
    >
      <div className={css.content}>
        <div className={css.title}>
          {headline ?? String(t('timer.promo-title'))}
        </div>
        <div>
          <Countdown date={endDate} renderer={renderer} />
        </div>

        {onClose && (
          <button className={css.closeButton} onClick={onClose}>
            <Close />
          </button>
        )}
      </div>
    </div>
  );
};

export default Timer;
